var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _g3, _g4, _path7, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuterImg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 137,
    viewBox: "0 0 150 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.949 67.7442C132.956 74.616 131.777 81.4375 129.464 87.9082C125.976 97.6619 120.028 106.349 112.196 113.129C101.3 122.585 87.3506 127.781 72.9231 127.758C62.5247 127.755 52.3058 125.048 43.2692 119.903C34.2325 114.759 26.6886 107.354 21.3777 98.4137C20.5431 97.0146 19.7699 95.5787 19.0458 94.106C15.0093 85.9043 12.91 76.8853 12.9095 67.7442C12.9012 61.5686 13.8492 55.4291 15.7199 49.5437C18.5433 40.6954 23.3778 32.6214 29.8445 25.9546C36.3111 19.2878 44.2341 14.2095 52.9922 11.1178C59.4001 8.86723 66.1438 7.72184 72.9354 7.73052C78.4359 7.72538 83.9111 8.47276 89.209 9.95188C100.598 13.1652 110.784 19.6719 118.487 28.6547C126.19 37.6376 131.068 48.6962 132.507 60.4419C132.803 62.8647 132.951 65.3033 132.949 67.7442Z",
    fill: "url(#paint0_linear_222_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.372 85.1713C130.126 85.9813 129.869 86.7913 129.574 87.6258L129.464 87.9449C125.98 97.7009 120.032 106.389 112.196 113.165C111.349 113.889 110.465 114.614 109.582 115.301L75.6723 71.254L73.8314 68.8608L72.9846 67.7686L74.0892 68.0999L130.372 85.1713Z",
    fill: "#8253D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9233 67.7441L20.2733 96.585C19.8314 95.7627 19.4019 94.9404 18.9846 94.1304C14.9494 85.9283 12.8501 76.9096 12.8483 67.7686C12.8411 64.3588 13.1285 60.9548 13.7073 57.5945C15.5912 46.5949 20.5139 36.3414 27.9192 27.9927L63.9396 59.9018L70.4074 65.6209L72.9233 67.7441Z",
    fill: "url(#paint1_linear_222_106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4191 69.0942L13.7563 57.5701C15.6402 46.5705 20.5628 36.317 27.9681 27.9683L63.9886 59.8773L68.4191 69.0942Z",
    fill: "#FF16BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9232 67.7439L20.2732 96.5848C19.8314 95.7626 19.4019 94.9403 18.9846 94.1303L70.4564 65.5962L72.9232 67.7439Z",
    fill: "#BB0088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.196 113.129C101.3 122.585 87.3506 127.781 72.9231 127.758C62.5247 127.755 52.3059 125.048 43.2692 119.903C34.2325 114.759 26.6886 107.353 21.3777 98.4136L77.1941 67.3882H77.3659L77.1941 67.7073L112.196 113.129Z",
    fill: "#C2008D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0582 68.3577L15.7078 49.5436C18.5312 40.6953 23.3657 32.6213 29.8323 25.9545C36.299 19.2877 44.2219 14.2094 52.98 11.1177L73.0582 68.3577Z",
    fill: "#FF16BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.773 119.412C101.366 128.239 87.3463 133.019 72.9232 132.998C61.2278 133.004 49.7459 129.865 39.68 123.91C29.6141 117.955 21.3343 109.403 15.7078 99.15L72.9232 67.3882H73.0951L72.9232 67.7073L112.773 119.412Z",
    fill: "#FF16BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9173 6.02441L68.7873 68.3821L6 47.7517C8.95168 38.7493 13.8057 30.4875 20.2327 23.5269C26.6596 16.5664 34.5089 11.0701 43.2477 7.41124C44.4505 6.92033 45.6655 6.44169 46.9173 6.02441Z",
    fill: "url(#paint2_linear_222_106)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_222_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.232 75.6086C106.078 59.092 95.807 42.5843 79.2903 38.7378C62.7737 34.8912 46.266 45.1623 42.4194 61.6789C38.5729 78.1956 48.844 94.7032 65.3606 98.5498C81.8773 102.396 98.3849 92.1253 102.232 75.6086Z",
    fill: "#E4DAF7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.17 41.3184H72.466C69.6229 41.3184 67.3181 43.6232 67.3181 46.4663V89.3287C67.3181 92.1718 69.6229 94.4766 72.466 94.4766H144.17C147.013 94.4766 149.318 92.1718 149.318 89.3287V46.4663C149.318 43.6232 147.013 41.3184 144.17 41.3184Z",
    fill: "url(#paint3_linear_222_106)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.885 46.311H130.706C129.791 46.311 129.049 47.0528 129.049 47.9677V53.2991C129.049 54.2141 129.791 54.9558 130.706 54.9558H141.885C142.8 54.9558 143.542 54.2141 143.542 53.2991V47.9677C143.542 47.0528 142.8 46.311 141.885 46.311Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.318 74.8423H67.3181V83.7983H149.318V74.8423Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.542 62.7613H73.6949C73.4 62.7613 73.1172 62.6442 72.9087 62.4357C72.7001 62.2272 72.583 61.9443 72.583 61.6495C72.583 61.3546 72.7001 61.0718 72.9087 60.8633C73.1172 60.6547 73.4 60.5376 73.6949 60.5376H143.542C143.837 60.5376 144.12 60.6547 144.328 60.8633C144.537 61.0718 144.654 61.3546 144.654 61.6495C144.654 61.9443 144.537 62.2272 144.328 62.4357C144.12 62.6442 143.837 62.7613 143.542 62.7613Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.136 70.794H73.6949C73.4 70.794 73.1172 70.6769 72.9087 70.4684C72.7001 70.2599 72.583 69.9771 72.583 69.6822C72.583 69.3873 72.7001 69.1045 72.9087 68.896C73.1172 68.6875 73.4 68.5703 73.6949 68.5703H102.136C102.431 68.5703 102.714 68.6875 102.923 68.896C103.131 69.1045 103.248 69.3873 103.248 69.6822C103.248 69.9771 103.131 70.2599 102.923 70.4684C102.714 70.6769 102.431 70.794 102.136 70.794Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.27 89.4908H129.049C128.754 89.4908 128.471 89.3737 128.263 89.1652C128.054 88.9566 127.937 88.6738 127.937 88.379C127.937 88.0841 128.054 87.8013 128.263 87.5927C128.471 87.3842 128.754 87.2671 129.049 87.2671H143.27C143.565 87.2671 143.847 87.3842 144.056 87.5927C144.264 87.8013 144.381 88.0841 144.381 88.379C144.381 88.6738 144.264 88.9566 144.056 89.1652C143.847 89.3737 143.565 89.4908 143.27 89.4908Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_222_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137 68.5C137.008 76.3436 135.662 84.1297 133.022 91.5154C129.042 102.648 122.253 112.564 113.315 120.302C100.879 131.096 84.959 137.027 68.493 137C56.6254 136.996 44.9627 133.907 34.6493 128.035C24.3358 122.163 15.726 113.71 9.6647 103.506C8.71224 101.909 7.82983 100.27 7.00343 98.5895C2.39662 89.2281 0.000608817 78.9338 6.17281e-05 68.5C-0.00941612 61.4512 1.0726 54.4435 3.20762 47.7259C6.42993 37.6264 11.9475 28.4107 19.3278 20.8012C26.7081 13.1917 35.7505 7.39521 45.7461 3.8663C53.0593 1.2975 60.7558 -0.00984794 68.507 5.58493e-05C74.7847 -0.00580707 81.0335 0.847258 87.0799 2.53553C100.078 6.20326 111.703 13.63 120.495 23.8831C129.286 34.1361 134.853 46.7585 136.496 60.1651C136.834 62.9305 137.002 65.714 137 68.5Z",
    fill: "#8253D8",
    fillOpacity: 0.02
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_222_106)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 40,
    width: 83,
    height: 55,
    rx: 6,
    fill: "#FBFBFB",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 40.5,
    width: 82,
    height: 54,
    rx: 5.5,
    stroke: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bdi_222_106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0437 89.3545C79.8523 88.3843 80.8507 87.6121 81.7416 88.0411L109.322 101.321C110.258 101.771 110.218 103.117 109.258 103.512L97.1943 108.469C96.6949 108.674 96.2601 109.01 95.9358 109.442L88.104 119.87C87.4804 120.7 86.1681 120.4 85.9672 119.381L80.0437 89.3545Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0437 89.3545C79.8523 88.3843 80.8507 87.6121 81.7416 88.0411L109.322 101.321C110.258 101.771 110.218 103.117 109.258 103.512L97.1943 108.469C96.6949 108.674 96.2601 109.01 95.9358 109.442L88.104 119.87C87.4804 120.7 86.1681 120.4 85.9672 119.381L80.0437 89.3545Z",
    stroke: "#8253D8",
    strokeWidth: 0.55
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.246 89.1544C81.7574 88.7587 82.4743 88.6284 83.1504 88.9539L107.55 100.702C108.969 101.386 108.909 103.427 107.452 104.025L97.6439 108.056C97.2032 108.237 96.791 108.476 96.4175 108.765L81.246 89.1544Z",
    fill: "#F2F2F2"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_222_106)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 88.5,
    r: 8.5,
    fill: "#040404",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_222_106",
    x: -8.3877,
    y: -12.0693,
    width: 161.427,
    height: 161.426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_222_106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_222_106",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_222_106",
    x: -2,
    y: -2,
    width: 141,
    height: 141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_222_106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_222_106",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_222_106",
    x: 65,
    y: 39,
    width: 85,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_222_106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_222_106",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bdi_222_106",
    x: 75.7446,
    y: 83.644,
    width: 38.532,
    height: 40.981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_222_106"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_222_106",
    result: "effect2_dropShadow_222_106"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_222_106",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_222_106"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_222_106",
    x: 64,
    y: 71,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_222_106"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_106",
    x1: 72.9292,
    y1: 7.73047,
    x2: 72.9292,
    y2: 127.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8253D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF16BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_106",
    x1: 42.8857,
    y1: 27.9927,
    x2: 40.9774,
    y2: 91.9091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF16BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8253D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_106",
    x1: 37.3936,
    y1: 6.02441,
    x2: 37.3936,
    y2: 68.3821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF16BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8253D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_222_106",
    x1: 142.135,
    y1: 44.8541,
    x2: 73.2499,
    y2: 91.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8253D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF16BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126.937,
    height: 126.998,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuterImg6);
export default __webpack_public_path__ + "static/media/futer_img6.58c86d143ef90f218f68d5056820476d.svg";
export { ForwardRef as ReactComponent };